import janusApi from "../../janus-api";

const PARTICIPANT_JOINED = "kbport/participant/JOIN";
const PARTICIPANT_DETACHED = "kbport/participant/DETACH";
const PARTICIPANT_STREAM_SET = "kbport/participant/SET_STREAM";
const PARTICIPANT_UPDATE_STATUS = "kbport/participant/UPDATE_STATUS";
const PARTICIPANT_UPDATE_LOCAL_STATUS =
  "kbport/participant/UPDATE_LOCAL_STATUS";
const PARTICIPANT_SPEAKING = "kbport/participant/PARTICIPANT_SPEAKING";
const PARTICIPANT_SET_FOCUS = "kbport/participant/PARTICIPANT_SET_FOCUS";

const addParticipant = (participant) => {
  const { id, display, isPublisher, isLocalScreen, isIgnored } = participant;

  return {
    type: PARTICIPANT_JOINED,
    payload: { id, display, isPublisher, isLocalScreen, isIgnored },
  };
};

const removeParticipant = (participantId) => {
  return function (dispatch, getState) {
    const room = getState().room;
    console.log("room: ", room);
    janusApi
      .removeParticipant(participantId, room.roomId, room.secret)
      .then((data) => {
        console.log("in return: ", data);
        dispatch(removeParticipantAction(participantId));
      });
  };
};

const removeParticipantAction = (participantId) => ({
  type: PARTICIPANT_DETACHED,
  payload: participantId,
});

const setStream = (participantId) => ({
  type: PARTICIPANT_STREAM_SET,
  payload: participantId,
});

const toggleAudio = (id) => {
  return function () {
    janusApi.toggleAudio(id);
  };
};

const toggleVideo = (id) => {
  return function () {
    janusApi.toggleVideo();
  };
};

const reconnect = (id) => {
  return function () {
    janusApi.reconnectFeed(id);
  };
};

const updateStatus = (id, status) => ({
  type: PARTICIPANT_UPDATE_STATUS,
  payload: { id, status },
});

const updateLocalStatus = ({ audio, video }) => ({
  type: PARTICIPANT_UPDATE_LOCAL_STATUS,
  payload: { audio, video },
});

const participantSpeaking = (id, speaking) => ({
  type: PARTICIPANT_SPEAKING,
  payload: { id, speaking },
});

const autoSetFocus = (force = false) => {
  return function (dispatch, getState) {
    const participants = getState().participants;
    const { id: oldFocusId, focus } = focusedParticipant(participants) || {};
    if (!force && focus === "user") return;

    const { id: nextFocusId } = nextFocusedParticipant(participants) || {};
    const { id: localId } = localParticipant(participants) || {};

    const focusId = nextFocusId || oldFocusId || localId;
    if (focusId) dispatch(setFocus(focusId, "auto"));
  };
};

const setFocus = (id, cause = "user") => ({
  type: PARTICIPANT_SET_FOCUS,
  payload: { id, cause },
});

const unsetFocus = () => autoSetFocus(true);
const startScreenSharing = () => () => janusApi.publishScreen();
const stopScreenSharing = (id) => () => janusApi.unpublishFeed(id);

/**
 * Local participant
 */
const localParticipant = (state) =>
  Object.values(state).find((p) => p.isPublisher && !p.isLocalScreen);

/**
 */
const focusedParticipant = (state) => {
  const participants = Object.values(state);
  return participants.find((p) => p.focus);
};

/**
 */
const nextFocusedParticipant = (state) => {
  const participants = Object.values(state);
  const [speaker] = Object.values(participants)
    .filter((p) => p.speaking)
    .sort((a, b) => a.speakingChange - b.speakingChange);

  return speaker;
};

const actionCreators = {
  addParticipant,
  removeParticipant,
  removeParticipantAction,
  setStream,
  toggleAudio,
  toggleVideo,
  reconnect,
  updateStatus,
  updateLocalStatus,
  participantSpeaking,
  setFocus,
  unsetFocus,
  autoSetFocus,
  startScreenSharing,
  stopScreenSharing,
};

const actionTypes = {
  PARTICIPANT_JOINED,
  PARTICIPANT_DETACHED,
  PARTICIPANT_STREAM_SET,
  PARTICIPANT_UPDATE_STATUS,
  PARTICIPANT_UPDATE_LOCAL_STATUS,
  PARTICIPANT_SPEAKING,
  PARTICIPANT_SET_FOCUS,
};

const selectors = {
  localParticipant,
  focusedParticipant,
};

export const initialState = {};

const reducer = function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PARTICIPANT_JOINED: {
      const participant = { ...payload, stream_timestamp: null };
      return {
        ...state,
        [participant.id]: participant,
      };
    }

    case PARTICIPANT_DETACHED: {
      return Object.keys(state)
        .filter((key) => parseInt(key) !== payload)
        .reduce((obj, key) => {
          obj[key] = state[key];
          return obj;
        }, {});
    }

    case PARTICIPANT_STREAM_SET: {
      return {
        ...state,
        [payload]: {
          ...state[payload],
          stream_timestamp: new Date(Date.now()),
        },
      };
    }

    case PARTICIPANT_UPDATE_STATUS: {
      const { id, status } = payload;
      const newState = { ...state, [id]: { ...state[id], ...status } };
      if (!newState[id].audio) newState[id].speaking = false;
      return newState;
    }

    case PARTICIPANT_UPDATE_LOCAL_STATUS: {
      const id = localParticipant(state).id;
      const { audio, video } = payload;
      const newState = { ...state, [id]: { ...state[id], audio, video } };
      if (!audio) newState[id].speaking = false;
      return newState;
    }

    case PARTICIPANT_SPEAKING: {
      const { id, speaking } = payload;
      return {
        ...state,
        [id]: { ...state[id], speaking, speakingChange: Date.now() },
      };
    }

    case PARTICIPANT_SET_FOCUS: {
      const { id, cause } = payload;
      const oldFocus = Object.values(state).find((p) => p.focus);
      const newState = { ...state, [id]: { ...state[id], focus: cause } };
      if (oldFocus && oldFocus.id !== id) {
        delete newState[oldFocus.id].focus;
      }
      return newState;
    }

    default:
      return state;
  }
};

export { actionCreators, actionTypes, selectors };

export default reducer;
